export const PAYMENT_SUCCESS_BANNER = {
    TOTAL_AMOUNT: "total-amount",
    PAID_AMOUNT: "paid-amount",
    TIP_TEST_IDS: "tip",
    SUBSCRIPTION_VALUE: "subscription-value",
    SAVING_DIGIT: "saving-digit",
    MERCH_BANNER: "merch-banner",
    STATUS_BANNER_BG_IMAGE: "status-banner-bg-image",
    RESERVATION_STATUS: "reservation-status",
    BOOKING_TEXT_STATUS: "text-status",
    RESERVATION_IMAGE: "reservation-image",
};
